import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PDSService } from '../../../services/pds.service';

@Component({
  standalone: true,
  template: '',
})
export class WhiteLabelpdsRedirectComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pdsService: PDSService,
  ) {
    this.route.queryParams.subscribe((params) => {
      const labelName = params['partnerCode'];
      const promo = params['promo'];
      const queryParams: any = {};
      if (promo) {
        queryParams.promo = promo;
      }
      if (labelName === 'vacatio' || labelName === 'Klook') {
        this.pdsService.getWhiteLabelPartnerCode();
        this.router.navigate(['/policydocumentation', labelName], { queryParams });
      } else {
        this.router.navigate(['/error']);
      }
    });
  }
}
